import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AdminLayout } from "../components/AdminLayout";
import { useAuth } from "../auth/AuthContext";
import {
  JobHeader,
  JobDoorCodeCard,
  JobObservationsCard,
  JobActionPanel,
  JobChecklistCard,
  JobPhotosCard,
  JobSignatureCard,
  JobSidebar,
  useJobDetail,
} from "../components/jobdetail";
import { EntityNotes } from "../components/EntityNotes";
import { useI18n } from "../i18n/I18nContext";

export default function JobDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const { user } = useAuth();
  const { t } = useI18n();
  const d = useJobDetail(id);

  if (!d.job)
    return (
      <AdminLayout>
        <div className="text-slate-500">{t("Carregando…")}</div>
      </AdminLayout>
    );

  const isAdmin = user?.role === "admin" || user?.role === "supervisor";

  return (
    <AdminLayout>
      <JobHeader job={d.job} client={d.client} team={d.team} onBack={() => nav(-1)} />
      <JobDoorCodeCard doorCode={d.client?.door_code} />
      <JobObservationsCard observations={d.client?.observations} />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-6">
          <JobActionPanel
            job={d.job}
            client={d.client}
            team={d.team}
            busy={d.busy}
            isAdmin={isAdmin}
            onStart={d.startJob}
            onFinish={d.finishJob}
            onSetStatus={d.setStatus}
            onRevertToScheduled={d.revertToScheduled}
          />
          <JobChecklistCard
            checklist={d.checklist}
            jobStatus={d.job.status}
            onToggle={d.toggleChecklistItem}
          />
          <JobPhotosCard
            before={d.before}
            after={d.after}
            onBeforeChange={d.setBefore}
            onAfterChange={d.setAfter}
          />
          <JobSignatureCard
            ref={d.signatureRef}
            signature={d.signature}
            onSaved={d.setSignature}
          />
          <div className="cm-card p-4">
            <EntityNotes entityType="job" entityId={d.job.id} />
          </div>
          {d.client?.id && (
            <div className="cm-card p-4">
              <EntityNotes
                entityType="client"
                entityId={d.client.id}
                title={t("Notas do cliente (todas as visitas)")}
              />
            </div>
          )}
        </div>

        <JobSidebar job={d.job} client={d.client} team={d.team} />
      </div>
    </AdminLayout>
  );
}
